import React from "react"
import PropTypes from "prop-types"
import * as yup from "yup"
import { useTranslation } from "react-i18next"
import { Formik, Form, Field } from "formik"
import { Spacer, Button } from "@bw/bits"
import { Input, FormField } from "@bw/forms"

const Login = ({ onSubmit, setActiveStep }) => {
  const { t } = useTranslation()
  const initialValues = { email: "", password: "" }

  return (
    <Spacer>
      <Formik
        initialValues={initialValues}
        validationSchema={yup.object().shape({
          email: yup.string().required(),
          password: yup.string().required(),
        })}
        onSubmit={(values, actions) => {
          actions.setSubmitting(true)

          onSubmit(values).finally(() => {
            actions.setSubmitting(false)
          })
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <FormField title={t("authentication:email")} name="email">
              <Field type="text" id="email" name="email" component={Input} />
            </FormField>

            <FormField title={t("authentication:password")} name="password">
              <Field
                type="password"
                id="password"
                name="password"
                component={Input}
              />
            </FormField>

            <Button
              submit
              small
              label={t("authentication:loginSubmit")}
              disabled={isSubmitting}
            />
          </Form>
        )}
      </Formik>
      <div>
        <Button
          onClick={() => setActiveStep("register")}
          plain
          small
          label={t("authentication:iDontHaveAnAccount")}
        />
      </div>
      <div>
        <Button
          onClick={() => setActiveStep("forgot")}
          plain
          small
          label={t("authentication:iForgotMyPassword")}
        />
      </div>
    </Spacer>
  )
}

Login.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default Login
